<template>
  <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div id="container1" class="modal-container"
              
            >

              <div class="modal-header">
                <slot name="header">
                  default header
                </slot>
              </div>

              <div class="modal-body" v-bind:style="heightClass()">
                <slot name="body">
                  default body
                </slot>
                <slot name="files">
                  Прикреплений файлов нет
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="btn btn-sm btn-danger" @click="$emit('close')">
                    Закрыть
                  </button>
                  <slot name="prevButton">
                    <button class="btn btn-sm btn-info" @click="$emit('prev')">
                        Предыдущая запись
                    </button>
                  </slot>
                  <slot name="nextButton" v-bind:disabledNext="disabledNext" >
                    <button :disabled="disabledNext"
                    class="btn btn-sm btn-info" @click="$emit('next')">
                        Следующая запись
                    </button>
                  </slot>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
</template>

<script>
  export default {
    name: 'ReceptionHistory',
    data () { 
        return {
            disabledNext: false
        };
    },
    mounted() {
        
    },
    methods: {
      close() {
        this.$emit('close');
      },
      heightClass() {
        const maxHeight = document.documentElement.clientHeight;
        //const container = document.getElementById('container1').style;
        //container.height  = maxHeight + 'px';
        //console.log(maxHeight, container);
        return { 'max-height': maxHeight-(maxHeight*0.5) + 'px', overflow: 'auto'};
      }
    },
  };
</script>



<style>
 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  max-height: auto;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  overflow: auto;
  height: 50%;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>